import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import styles from "./LoginPage.module.css";
import { useAuth } from "../contexts/AuthContext";
import Button from "components/common/Button";
import { Helmet } from "react-helmet";

const ForgetPassword = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');

  const [alert, setAlert] = useState(null);

  const { forgetPassword } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await forgetPassword(email);
      if (response.success) {
        setAlert({ type: 'success', message: response.data.message });
        setTimeout(() => {
          setAlert(null);
        }, 5000);
      }
    } catch (err) {
      setError('Identifiants invalides.');
    }
  };

  return (
    <div className="page-content">
      <Helmet>
        <title>Mot de passe oublié - Pharos</title>
        <meta name="description" content="Réinitialisez votre mot de passe en entrant votre adresse e-mail. Un lien de réinitialisation vous sera envoyé." />
        <meta property="og:title" content="Mot de passe oublié - Pharos" />
        <meta property="og:description" content="Réinitialisez votre mot de passe en entrant votre adresse e-mail. Un lien de réinitialisation vous sera envoyé." />
        <meta property="og:type" content="website" />
      </Helmet>
      <section className={`global-section ${styles.section}`}>
        <div className={`global-container ${styles.content}`}>
          <div className={styles.loginContainer}>
            <div className={styles.formContainer}>
              <h1 className="h2">Mot de passe oublié</h1>
              <p className={styles.Description}>Entrez votre adresse e-mail ci-dessous, et nous vous enverrons un lien pour réinitialiser votre mot de passe.</p>
              <form onSubmit={handleSubmit}>
                {alert && (
                  <div className={`${styles.alert} ${styles[alert?.type]}`}>
                    {alert?.message}
                  </div>
                )}
                <ul className={styles.InputsList}>
                  <li>
                    <label htmlFor="username">Nom d'utilisateur (email)</label>
                    <input
                      type="text"
                      name="username"
                      onChange={e => setEmail(e.target.value)}
                      placeholder="Nom d'utilisateur"
                    />
                    {error && <p className={styles.error}>{error}</p>}
                  </li>
                </ul>

                <Button type="submit">Réinitialiser</Button>

              </form>
              <div className={styles.Description}>Vous ne possédez pas encore de compte ? <Link className={styles.NavigateLink} to='/inscription'>Inscrivez-vous ici</Link></div>
            </div>
            <div className={styles.image}>
              <img src={`/images/ready-to-rock.webp`} alt="" aria-hidden="true"></img>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ForgetPassword;
